// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".goods_detail .goods_detail_wrapper[data-v-c8b6bfc6]{z-index:200;position:absolute;left:50%;top:50%;-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%);width:375px;background:#f0f2f5}.goods_detail .goods_detail_wrapper.on[data-v-c8b6bfc6]{position:fixed}", ""]);
// Exports
module.exports = exports;
